import { render, staticRenderFns } from "./CrearProducto.vue?vue&type=template&id=4b87141d&scoped=true"
import script from "./CrearProducto.vue?vue&type=script&lang=js"
export * from "./CrearProducto.vue?vue&type=script&lang=js"
import style0 from "./CrearProducto.vue?vue&type=style&index=0&id=4b87141d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87141d",
  null
  
)

export default component.exports